import { z } from "zod";
export const DTOPageRedirectCreateBody = z.object({
    pagePersistentId: z.string(),
    path: z.string(),
});
export const DTOPageRedirectUpdateBody = DTOPageRedirectCreateBody.partial();
export const DTOPageRedirect = z.object({
    id: z.string(),
    pagePersistentId: z.string(),
    path: z.string(),
});
export const DTOPageRedirectListResponse = z.object({
    redirects: DTOPageRedirect.array(),
});
export const DTOPageRedirectResponse = z.object({
    redirect: DTOPageRedirect,
});
export const DTOPageRedirectDeleteResponse = z.object({
    success: z.boolean(),
});
